import { render, staticRenderFns } from "./proposal-categories.vue?vue&type=template&id=dbaf62ac"
import script from "./proposal-categories.vue?vue&type=script&lang=js"
export * from "./proposal-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports